/**
 * Player Card Types
 *
 * Cards that can be dealt to players during sessions.
 * Visibility tiers: gm_only → private (one player) → revealed (everyone).
 */
import { z } from 'zod';
// =============================================================================
// ENUMS
// =============================================================================
export const CardTypeSchema = z.enum(['secret', 'item', 'clue', 'rumor', 'quest']);
export const CardVisibilitySchema = z.enum(['gm_only', 'private', 'revealed']);
// =============================================================================
// PLAYER CARD
// =============================================================================
export const PlayerCardSchema = z.object({
    id: z.string().uuid(),
    campaignId: z.string().uuid(),
    title: z.string(),
    frontText: z.string(),
    backText: z.string().optional(),
    cardType: CardTypeSchema.default('secret'),
    recipientId: z.string().uuid().optional(),
    visibility: CardVisibilitySchema.default('gm_only'),
    createdAt: z.string().optional(),
    updatedAt: z.string().optional(),
});
//# sourceMappingURL=card-types.js.map